export default [
  {
    name: `instruction_1`,
    title: `Bewegen Sie Ihren Finger, um in 360° zu erkunden.`,
  },
];
